import { DestroyRef, inject, PLATFORM_ID } from '@angular/core';
import { ConfigService } from '@core/shared/config';
import { RouterLinkResolverService } from '@core/shared/feature';
import { BehaviorSubject } from 'rxjs';
import { takeWhileAlive } from '../../utils';
import { FrontendFeatureRegistry } from './feature.registry';
import * as i0 from "@angular/core";
import * as i1 from "./feature.registry";
import * as i2 from "@core/shared/feature";
import * as i3 from "@core/shared/config";
export let FeatureService = /*#__PURE__*/(() => {
  class FeatureService {
    // list of all Features that are enabled + loaded
    get loadedPlugins$() {
      return this.registry.getLoadedPlugins$();
    }
    // list of all installed FeaturePlugins, independent of currently active user/company and its settings.
    get allOptInFeaturePluginInfos$() {
      return this.registry.allOptInFeaturePluginInfos$;
    }
    constructor(registry, resolverService, config,
    // debug:DevToolsRegistry,
    platformId) {
      this.registry = registry;
      this.resolverService = resolverService;
      this.platformId = platformId;
      this.destroyRef = inject(DestroyRef);
      this.resolvers$ = new BehaviorSubject(null);
      // cache routerLinkResolvers of current platform 
      this.resolverService.getRouterLinkResolvers(config.getPlatform()).pipe(takeWhileAlive(this.destroyRef)).subscribe(allResolvers => this.resolvers$.next(allResolvers));
    }
    getLoadedFeatures() {
      return this.registry.getLoadedPlugins$();
    }
    static {
      this.ɵfac = function FeatureService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FeatureService)(i0.ɵɵinject(i1.FrontendFeatureRegistry), i0.ɵɵinject(i2.RouterLinkResolverService), i0.ɵɵinject(i3.ConfigService), i0.ɵɵinject(PLATFORM_ID));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: FeatureService,
        factory: FeatureService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return FeatureService;
})();